import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GiftcardSaveStepComponent } from './giftcard-save-step.component';



@NgModule({
  declarations: [
    GiftcardSaveStepComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [GiftcardSaveStepComponent]
})
export class GiftcardSaveStepModule { }
